import { Pipe, PipeTransform } from '@angular/core';

import { AcrisCarCodesService } from './acriss-car-codes.service';
import { CarCategories, CarTypes } from './car-detail';

@Pipe({
  standalone: false,
  name: 'vehicleTypeFormat'
})
export class VehicleTypePipe implements PipeTransform {

  private type: CarTypes;
  private category: CarCategories;

  constructor(private acrisCarCodesService: AcrisCarCodesService) {
    this.type = this.acrisCarCodesService.types;
    this.category = this.acrisCarCodesService.categories;
  }

  transform(vehicleTypeRaw: string) {

    // Please note: unusual behavior for types and categories
    // is for achieving business needs
    // see story TFS [CB_02_5]:
    // Only the certain combinations of car type and car category must be shown

    if (!vehicleTypeRaw || vehicleTypeRaw.length !== 4) {
      return '';
    }

    const carCategoryCode = vehicleTypeRaw.toUpperCase()[0];
    const carCategory =
      this.acrisCarCodesService.getCategoryByCode(carCategoryCode);

    if (!carCategory) {
      return '';
    }

    let categoryName = carCategory.name;
    switch (carCategory.code) {
      case this.category.Intermediate.code:
      case this.category.IntermediateElite.code:
        categoryName = 'Midsize';
        break;
      default:
        break;
    }

    const carTypeCode = vehicleTypeRaw.toUpperCase()[1];
    const carType = this.acrisCarCodesService.getCarTypeByCode(carTypeCode);

    if (!carType) {
      return '';
    }

    let typeName = carType.name;
    switch (carType.code) {
      case this.type.WagorOrEstate.code:
        typeName = 'Wagon';
        break;
      case this.type.PassengerVan.code:
        typeName = 'Van';
        break;
      case this.type.Sport.code:
        typeName = 'SportsCar';
        break;
      case this.type.Convertible.code:
      case this.type.Suv.code:
      case this.type.PickUpRegularCar.code:
      case this.type.PickUpExtendedCar.code:
      case this.type.SpecialOfferCar.code:
      case this.type.Monospace.code:
      case this.type.RecreationalVehicle.code:
      case this.type.Roadster.code:
      case this.type.Crossover.code:
        break;
      case this.type.Special.code:
        if (carCategory.code === this.category.Special.code) {
          typeName = '';
        }
        break;
      default:
        typeName = '';
        break;
    }

    return `${categoryName} ${typeName}`.trim();
  }
}
